(function() {
    'use strict';

    angular
        .module('elogbooks')
        .config(Translations);

    function Translations($translateProvider) {
        $translateProvider.translations('en-gb', {
            MERIDIAN_DOC_TYPE: 'Vantify Risk Manager Document Type',
            RISKWISE_DOC_TYPE: 'RiskWise Document Type',
            DATASTATION_DOC_TYPE: 'DataStation Document Type',
            FILE_SEND_TO_MERIDIAN_SUCCESS: 'The file has been sent to Vantify Risk Manager successfully',

            INSPECTIONDATE: 'Inspection Date',
            NEXTINSPECTIONDATE: 'Next Inspection Date',

            UPLOAD_TO_RISKWISE: 'Send to RiskWise',
            RISKWISE_UPLOAD_ADD: 'Send to RiskWise',
            PRIMARY: 'Primary',
            SECONDARY: 'Secondary',

            INVALID_RISKWISE_SYSTEM_TYPE: 'Please select a valid Riskwise System Type',
            INTEGRATION_SEND_TO: 'Send to',

            RISKWISE_UPLOAD_PENDING: 'Riskwise upload pending',
            RISKWISE_UPLOADED: 'Uploaded to riskwise',
            RISKWISE_UPLOAD_ERROR: 'Riskwise upload error',

            MERIDIAN_UPLOAD_PENDING: 'Vantify Risk Manager Upload Pending',
            MERIDIAN_UPLOADED: 'Vantify Risk Manager Upload Successful',
            MERIDIAN_UPLOAD_ERROR: 'Vantify Risk Manager Upload Failed',
            MERIDIAN_SYSTEM_LINK: 'Vantify Risk Manager System Link',
            GO_TO_VANTIFY_RISK_MANAGER: 'Go to Vantify Risk Manager'
        });
    }
})();
